import { costTypes } from './types/cost.types';

export const setCostType = type => {
    return {
        type: costTypes.SET_COST_TYPE,
        payload: {
            type
        }
    };
};

export const setCostDate = date => {
    return {
        type: costTypes.SET_COST_DATE,
        payload: {
            date
        }
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/actions/cost.actions.js